export default {
  testUA(str) {
    return navigator.userAgent.indexOf(str) > -1;
  },
  getUrlKey(name) {
    return (
      decodeURIComponent(
        (new RegExp(`[?|&]${name}=` + '([^&;]+?)(&|#|;|$)').exec(
          location.href
        ) || [, ''])[1]
        .replace(/\+/g, '%20')
      ) || null
    );
  },
  splitTags(tags) {
    if (!tags) {
      return [];
    }
    var values = tags.split(',');
    var result = [];
    for (let i = 0; i < values.length; i++) {
      const tag = values[i];
      if (tag) {
        result.push(tag);
      }
    }
    return result;
  },
  convert2Date(dateStr) {
    dateStr = dateStr.replace(/-/g, '/');
    let date = new Date(dateStr);
    return date;
  },
  delay(millseconds) {
    return new Promise((resolve, reject) => {
      setTimeout(resolve, millseconds)
    })
  }
};
